/**
 * Enables the "accordion" feature on the product card components.
 *
 * @author Todd Miller <todd.miller@tricomb2b.com>
 */

(function ($) {
  'use strict';

  let $cards;

  Drupal.behaviors.initializeProductCards = {
    attach: (context) => {
      if (context === document) initialize();
    },
  };

  /**
   * Just toggle that class when the user clicks on it.
   */
  function handleClick(e) {
    $(e.currentTarget).toggleClass('is-active');
  }

  /**
   * Cache elements, attach event handlers.
   */
  function initialize() {
    $cards = '.product-card';

    if (!$cards.length) return false;

    $('> h6', $cards).on('click', handleClick);
  }
})(jQuery);
